import { AuthService } from "projects/auth-app/src/app/auth/auth.service";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { MustMatch } from "src/functions/custom-validators";
import { NgxSmartModalService } from "ngx-smart-modal";

@Component({
  selector: "app-recovery",
  templateUrl: "./recovery.component.html",
  styleUrls: ["./recovery.component.scss"],
})
export class RecoveryComponent implements OnInit {
  public valueRadio: string;
  isValidEmail: boolean;
  formRecovery: FormGroup;
  token: string;
  show: boolean = false;
  constructor(
    private fb: FormBuilder,
    private auth: AuthService,
    private _route: ActivatedRoute,
    public ngxSmartModalService: NgxSmartModalService,
    public router: Router
  ) {
    this.valueRadio = "1";
    this.isValidEmail = false;
  }

  ngOnInit(): void {
    this._route.paramMap.subscribe((params) => {
      if (params.get("token")) {
        this.valueRadio = "3";
        this.token = params.get("token");
        this.loadFormPassword();
      } else {
        this.loadFormEmail();
      }
    });
  }

  loadFormPassword() {
    this.formRecovery = this.fb.group(
      {
        password1: ["", [Validators.required, Validators.minLength(8)]],
        password2: ["", [Validators.required, Validators.minLength(8)]],
      },
      {
        validator: MustMatch("password1", "password2"),
      }
    );
  }

  loadFormEmail() {
    this.formRecovery = this.fb.group({
      email: [
        "",
        Validators.compose([
          Validators.required,
          Validators.email,
          Validators.pattern("^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$"),
        ]
      )]
    })
  }

  get f() {
    return this.formRecovery.controls;
  }

  validateEmail() {
    let json = {
      email: this.f.email.value,
    };

    this.auth.recoveryPasswordRequest(json).subscribe(
      (resp) => {
        console.log(resp);
        this.isValidEmail = true;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  switchPass() {
    this.show = !this.show;
  }

  submit() {
    if (this.formRecovery.valid) {
      if (this.valueRadio == "1") {
        this.isValidEmail = true;

        let json = {
          email: this.f.email.value,
        };

        this.auth.recoveryPasswordRequest(json).subscribe(
          (resp) => {
            console.log(resp);
          },
          (error) => {
            console.log(error);
          }
        );
      }

      if (this.valueRadio == "3") {
        let json = {
          token: this.token,
          password: this.f.password1.value,
          passwordConfirmation: this.f.password2.value,
        };
        this.auth.recoveryPasswordChange(json).subscribe(
          (resp) => {
            console.log(resp);
            this.openModal();
          },
          (error) => {
            console.log(error);
          }
        );
      }
    }
  }

  openModal() {
    this.ngxSmartModalService.getModal("recovered").open();
  }

  closeModal() {
    this.ngxSmartModalService.getModal("recovered").close();
    this.goToLogin();
  }

  goToLogin() {
    this.router.navigate(["login"]);
  }
}
